import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import ScheduleModal from "../components/scheduleModal";
import { useParams, Link } from "react-router-dom";

const BillPassingHoView = () => {
  useAuthRedirect();
    const {grnNo, oldGrn} = useParams();
  const branch = localStorage.getItem("branch");
  const [poDetail, setPoDetail] = useState({});
    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false);

  const [subDetails, setSubDetails] = useState({})
  const [delDetails, setDelDetails] = useState({})
  const [transportDetail, setTransportDetail] = useState({})

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/billHo_Rejview?grnNo=${grnNo}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                grnheader_number: items[0].grnheader_number || "N/A",
                grnheader_date: items[0].grnheader_date || "N/A",
                grnHeader_poNumber: items[0].grnHeader_poNumber || "N/A",
                grnHeader_poDate: items[0].grnHeader_poDate || "N/A",
                supp: items[0].grnheader_suppliercode || "N/A",
                dcNo: items[0].grnheader_DcNumber || "N/A",
                dcDate: items[0].grnheader_DcDate || "N/A",
                iNo: items[0].grnheader_invoiceNumber || "N/A",
                iDate: items[0].grnheader_invoiceDate || "N/A",
                subValue: items[0].grnHeader_value || "N/A",
                disc: items[0].grnHeader_discount || "N/A",
                pf: items[0].grnHeader_pfCharges || "N/A",
                paymentTerms: items[0].grnHeader_pfCharges || "N/A",
                transport: items[0].grnHeader_transport || "N/A",
                gst: items[0].grnHeader_GSTtax || "N/A",
                delMethod: items[0].grnHeader_deliveryMethod || "N/A",
                delPlace: items[0].purchaseOrderHeader_deliveryPlace || "N/A",
                priceBasis: items[0].grnHeader_priceBasis || "N/A",
                remarks: items[0].grnHeader_remarks || "N/A",
                grandTot: items[0].grnHeader_totalValue || "N/A",
            };

            setPoDetail(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [grnNo]); 

  

  useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${poDetail.supp}`);
            const items = response.data.supDetails;
            console.log(response.data.supDetails);
            
            const storeReqHeaderCity = {
                supplierMaster_code : items[0].supplierMaster_code || "N/A",
                supplierMaster_name : items[0].supplierMaster_name || "N/A",
                supplierMaster_addressline1 : items[0].supplierMaster_addressline1 || "N/A",
                supplierMaster_addressline2 : items[0].supplierMaster_addressline2 || "N/A",
                supplierMaster_city : items[0].supplierMaster_city || "N/A",
                supplierMaster_pincode : items[0].supplierMaster_pincode || "N/A",
                
            };
            setSubDetails(storeReqHeaderCity);
            // setData(response.data.supDetails);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchSupplierDetails();
  }, [poDetail.supp]); 

  useEffect(() => {
  if (!oldGrn) return; 
  console.log(oldGrn);
  // avoid firing API when undefined

  const fetchDeliveryDetails = async () => {
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/rej_orderDetails?oldGrnNo=${oldGrn}`);
      const items = response.data.delDetails;
      console.log("API Response:", items);

      if (items.length > 0) {
        const deliveryDetails = {
          grnHeader_transport: items[0].grnHeader_transport,
          grnHeader_deliveryMethod: items[0].grnHeader_deliveryMethod,
          grnHeader_priceBasis: items[0].grnHeader_priceBasis,
          grnHeader_remarks: items[0].grnHeader_remarks,
          grnHeader_deliveryPlace: items[0].grnHeader_deliveryPlace,
          grnHeader_paymentTerms: items[0].grnHeader_paymentTerms,
          
        };
        setDelDetails(deliveryDetails);
      } else {
        console.warn("No delivery details found for GRN:", oldGrn);
      }
    } catch (error) {
      console.error("Error fetching Delivery Details:", error);
    }
  };

  fetchDeliveryDetails();
}, [oldGrn]);


  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/rej_fetch?supp=${poDetail.supp}&grnNo=${grnNo}`);
            const items = response.data.supDetails;
            console.log(response.data.supDetails);
            
            const storeReqHeaderCity = {
                supplierMaster_code : items[0].supplierMaster_code || "N/A",
                supplierMaster_name : items[0].supplierMaster_name || "N/A",
                supplierMaster_addressline1 : items[0].supplierMaster_addressline1 || "N/A",
                supplierMaster_addressline2 : items[0].supplierMaster_addressline2 || "N/A",
                supplierMaster_city : items[0].supplierMaster_city || "N/A",
                supplierMaster_pincode : items[0].supplierMaster_pincode || "N/A",
                
            };
            setTransportDetail(storeReqHeaderCity);
            // setData(response.data.supDetails);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchDetails();
  }, [poDetail.supp, grnNo]); 

  // rej_orderDetails




  useEffect(() => {
    axios.get(`https://rfs2.infraconsoft.net.in/api/billHo_RejviewDetails?grnNo=${grnNo}`)
      .then((response) => {
        if (response.data && response.data.Details) {
          setData(response.data.Details);
          console.log(response.data.Details);
          
        } else {
          setData([]); // Set an empty array to avoid errors
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setData([]); // Ensure data is always an array, even in case of an error
      });
  }, [grnNo]);
  

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
            <div className="back-div">
            <h2 className="add-txt">Bill Passing GRN View</h2>
            <Link to='/inventory/billPassingGrnRejectionView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
            </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
          <div className="form-row">
              <div className="form-group">
                <label>GRN Number :</label>
                <input type="text" name="PoNumber" value={poDetail.grnheader_number} readOnly />
              </div>
              <div className="form-group">
                <label>GRN Date :</label>
                <input
  type="text"
  name="endhrs"
  value={poDetail.grnheader_date ? 
         new Date(poDetail.grnheader_date).toLocaleDateString("en-GB") : ""}
  readOnly
/>

              </div>
            </div>


            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="scode" value={subDetails.supplierMaster_code} readOnly/>
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" name="sname" value={subDetails.supplierMaster_name} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>D.C No :</label>
                <input type="text" name="yourRefNo"   value={poDetail.dcNo} readOnly/>
              </div>
              <div className="form-group">
                <label>D.C Date :</label>
                <input
  type="text"
  name="endhrs"
  value={poDetail.dcDate ? 
         new Date(poDetail.dcDate).toLocaleDateString("en-GB") : ""}
  readOnly
/>

              
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Invoice No :</label>
                <input type="text" name="ourRefNo" value={poDetail.iNo} readOnly />
              </div>
              <div className="form-group">
                <label>Invoice Date :</label>
                <input type="text" name="endhrs"value={poDetail.iDate ? new Date(poDetail.iDate).toLocaleDateString("en-GB") : ""}readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="address1" value={subDetails.supplierMaster_addressline1} readOnly/>
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input type="text" name="address2" value={subDetails.supplierMaster_addressline2} readOnly/>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="city" value={subDetails.supplierMaster_city} readOnly/>
              </div>
              <div className="form-group">
                <label>Pin Code :</label>
                <input type="text" name="pincode" value={subDetails.supplierMaster_pincode} readOnly/>
              </div>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>P.O No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>Part No</th>
                    <th>UOM</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>GST%</th>
                    <th>PF%</th>
                    <th>Disc%</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
  {data.length > 0 ? (
    data.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.grnDetail_poNumber}</td>
        <td>{item.grnDetail_itemcode}</td>
        <td>{item.grnDetail_itemName}</td>
        <td>{item.grnDetail_uom}</td>
        <td>{item.grnDetail_packedQuantity}</td>
        <td>{item.grnDetail_acceptedQuantity}</td>
        <td>{item.grnDetail_price}</td>
        <td>{item.grnDetail_GSTpercentage}</td>
        <td>{item.grnDetail_pfPercentage}</td>
        <td>{item.grnDetail_discountPercentage}</td>
        <td>{item.grnDetail_value}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="9">No items</td>
    </tr>
  )}
</tbody>




              </table>
            </div>
                
          </form>
           
        </div>
         {/* Billing Summary */}
         <div className="po-bill-container">
                    <h2 className="po-bill-title">Billing Summary</h2>
                    <div className="po-bill-summary">
                    <div className="po-bill-item">
                        <span className="po-bill-label">Sub Total:</span>
                        
                        <span className="po-bill-value">₹{poDetail.subValue}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">GST (18%):</span>
                        <span className="po-bill-value">₹{poDetail.gst}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Disc (%):</span>
                        <span className="po-bill-value">₹{poDetail.disc}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">PF:</span>
                        <span className="po-bill-value">₹{poDetail.pf}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Transport:</span>
                        <span className="po-bill-value">{delDetails.grnHeader_transport}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Payment Terms:</span>
                        <span className="po-bill-value">{delDetails.grnHeader_paymentTerms}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Delivery Method:</span>
                        <span className="po-bill-value">{delDetails.grnHeader_deliveryMethod}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Delivery Place:</span>
                        <span className="po-bill-value">{delDetails.grnHeader_deliveryPlace}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Price Basis:</span>
                        <span className="po-bill-value">{delDetails.grnHeader_priceBasis}</span>
                    </div>
                    <div className="po-bill-item">
                        <span className="po-bill-label">Remarks:</span>
                        <span className="po-bill-value">{delDetails.grnHeader_remarks}</span>
                    </div>
                    <div className="po-bill-item po-bill-total">
                        <span className="po-bill-label">Total:</span>
                        <span className="po-bill-value">₹{poDetail.grandTot}</span>
                    </div>

                    </div>
              </div>

              
      </div>
      
    </div>
  );
};

export default BillPassingHoView;
